var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card main-card mt-2" }, [
    _c("div", { staticClass: "card-header" }, [
      _c("ul", { staticClass: "nav nav-tabs card-header-tabs nav-fill" }, [
        _c(
          "li",
          {
            staticClass: "nav-item hoverPointer",
            attrs: { "data-test-hook": "owner-info-tab-email-search-result" },
            on: {
              click: function($event) {
                _vm.tabIndex = 0
              }
            }
          },
          [
            _c("a", { staticClass: "nav-link", class: _vm.isActive(0) }, [
              _vm._v("Owner Information")
            ])
          ]
        )
      ])
    ]),
    _c("div", { staticClass: "card-body" }, [
      _vm.tabIndex == 0
        ? _c(
            "div",
            [_c("OwnerInformationTab", { attrs: { value: _vm.value } })],
            1
          )
        : _vm._e()
    ]),
    _c("div", { staticClass: "card-footer" }, [
      _c("span", { attrs: { id: "impersonate-email" } }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary mt-2",
            attrs: {
              type: "button",
              disabled: !_vm.hasAssociatedAccount(_vm.value),
              "data-toggle": "tooltip",
              title: _vm.hasAssociatedAccount(_vm.value)
                ? ""
                : "No Owner Account",
              "data-test-hook": "impersonate-button-email-search-result"
            },
            on: {
              click: function($event) {
                return _vm.ImpersonateEmail()
              }
            }
          },
          [_vm._v(" Impersonate User ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }